import { useSignups } from "Signups/state";

/*

Used to check if a Signup List has ANY respondents (1+ user signed up on any of its items)

*/

export function useSignupListHasRespondents() {
  const [state] = useSignups();
  const { signupItems } = state.currentSignupList;
  return signupItems.some((item) => Number(item.numberOfRespondents) > 0);
}
